import { Action, Event } from "render/hooks/useTracking";

const category = "PostScanIntroView";

export const postScanShareEvent = {
  pageView: (): Event => {
    return {
      category,
      action: Action.View,
    };
  },
  openModalClick: (): Event => {
    return {
      category,
      action: Action.Click,
      label: "open_modal_button",
    };
  },
  shareClick: (value: "nativeShare" | "download"): Event => {
    return {
      category,
      action: Action.Click,
      label: "share_button",
      value: value,
    };
  },
  continueClick: (): Event => {
    return {
      category,
      action: Action.Click,
      label: "continue_button",
    };
  },
};
